// extracted by mini-css-extract-plugin
export var chevronList = "ChevronList-module--chevronList--ATAht";
export var chevronList__item = "ChevronList-module--chevronList__item--LWLAr";
export var chevronList__item__bulletIcon = "ChevronList-module--chevronList__item__bulletIcon--NXfUG";